<template>
  <div class="home">
    <transition name="fade">
      <CustomPopup v-if="customPopUpIsVisible" @closeModal="toggleCustomPopUpModal" />
    </transition>
    <transition name="fade">
      <ChangeLocationModal
        v-if="changeLocationModalIsOpen"
        @changeStore="changeStore"
        @closeModal="toggleChangeLocationModal"
      />
    </transition>
    <transition name="fade">
      <ChangeServiceTypeModal
        v-if="changeServiceTypeModalIsOpen"
        @closeModal="toggleChangeServiceTypeModal"
        :updatedService="updatedService"
        @changeServiceType="changeServiceType"
      />
    </transition>
    <RadarMapView
      ref="radarMap"
      :selectedService="selectedService"
      :fitBounds="true"
      @clickedStoreId="scrollToTheStore"
      @selectStore="selectStore"
      v-if="mapType == 'RADAR'"
    />
    <MapView
      ref="map"
      :selectedService="selectedService"
      :fitBounds="true"
      @clickedStoreId="scrollToTheStore"
      @selectStore="selectStore"
      v-if="mapType == 'GOOGLE'"
    />
    <div class="rightPart">
      <div class="locations">
        <div class="serviceTypeSelection">
          <div v-if="storeConfig && visibleServices" class="orderTypesWrapper">
            <SegmentedControl
              v-if="storeConfig && visibleServices"
              :elements="visibleServices"
              :elementId="'service_type_id'"
              :selectedId="selectedService?.service_type_id"
              :elementName="'display_name'"
              @change="changeService"
              :loading="loading"
            />
          </div>
          <div class="addressDetails">
            <div
              class="addressWrapper"
              :style="{
                'grid-column': selectedService && !selectedService.requires_address ? 'span 2' : '',
              }"
            >
              <div v-if="selectedAddressLat && selectedAddressLng && addressTyped" class="remove">
                <a @click="addressValue('')" href="#">
                  <svg
                    class="clearSearchIcon"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.1161 6.6228L7.75908 6.97635L8.11437 7.33163L13.4572 12.6745L12.6745 13.4572L11.8466 12.6294L11.8449 12.6277L7.37718 8.11608L7.02364 7.75906L6.66835 8.11435L1.32551 13.4572L0.542786 12.6745L5.88563 7.33163L6.24062 6.97664L5.8842 6.62309L0.543158 1.32514L1.32551 0.542787L6.66835 5.88563L7.02334 6.24061L7.37689 5.88419L12.6748 0.543155L13.4572 1.32551L12.6294 2.15333L12.6277 2.15504L8.1161 6.6228ZM12.7648 13.5475C12.7649 13.5476 12.765 13.5478 12.7651 13.5479L12.7648 13.5475ZM0.452113 12.7651L0.452145 12.7651C0.452134 12.7651 0.452123 12.7651 0.452113 12.7651Z"
                      fill="black"
                      stroke="black"
                    />
                  </svg>
                </a>
              </div>
              <div
                @click="getUsersLocation"
                v-if="
                  selectedService &&
                  !selectedService.requires_address &&
                  (!selectedAddressLat && !selectedAddressLng) & !getLocationLoader
                "
                class="locationButton"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="470.392" height="470.502" viewBox="0 0 470.392 470.502">
                  <path
                    id="Path_19600"
                    data-name="Path 19600"
                    d="M567,44.875a16.687,16.687,0,0,0-5.773,1.574l-436.8,207.2a16.8,16.8,0,0,0,.7,30.625l155.93,64.574,64.574,155.93a16.8,16.8,0,0,0,30.8.875l207.2-436.8a16.8,16.8,0,0,0-16.625-23.976ZM532.875,97.023l-170.62,359.8-52.676-127.23a16.778,16.778,0,0,0-9.1-9.1L172.9,267.643Z"
                    transform="translate(-114.879 -44.813)"
                  />
                </svg>
              </div>
              <div v-if="getLocationLoader" class="loader smallLoader"></div>
              <RadarAutoComplete
                :placeholder="
                  selectedService?.requires_address ? 'Enter your address' : 'Enter your city, state or zip'
                "
                :from="'home'"
                :reqiresAddress="selectedService?.requires_address"
                @addressSelected="getLatAndLng"
                ref="radarAutoComplete"
                v-if="autoCompleteType == 'RADAR'"
              />
              <AutoComplete
                @placeChanged="getLatAndLng"
                @input="addressValue"
                :placeholder="
                  selectedService && selectedService?.requires_address
                    ? 'Enter your address'
                    : 'Enter your city, state or zip'
                "
                :requiresAddress="selectedService && selectedService?.requires_address"
                ref="autoComplete"
                v-if="autoCompleteType == 'GOOGLE'"
              />
              <p v-if="validAddressError" class="validation">
                {{ validAddressError }}
              </p>
            </div>
            <input
              v-if="selectedService && selectedService?.requires_address"
              type="text"
              placeholder="Apt/Suite"
              v-model="aptSuite"
            />
          </div>
          <div
            v-if="
              addresses && addresses.length != 0 && selectedService && selectedService?.requires_address && loggedIn
            "
            class="savedAddresses"
          >
            <label>Or Select Saved Address</label>
            <div class="addresses">
              <div
                v-for="address in firstTwoAddresses"
                :key="address.address_id"
                class="address"
                :style="{ backgroundColor: branding.dark_mode_enabled ? 'var(--background-color)' : '#FFFFFF' }"
              >
                <p>
                  {{ address.address1 }}, {{ address.city }},
                  {{ address.state_code }}
                  {{ address.postal_code }}
                </p>
                <a @click="selectAddress(address)" class="selectAddress" href="javascript:;">
                  <p>SELECT</p>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div v-if="storeConfig" class="results">
          <div v-if="stores">
            <div class="store" v-for="store in filteredStores" :key="store.store_id" @click="openInfoWindow(store)">
              <div class="storeInfoWrapper">
                <img v-if="store?.extra?.store_image" class="storeImage" :src="store?.extra?.store_image" alt="store" />
                <p class="testStore" v-if="store.test_store">Test Store</p>
                <div class="storeNameWrapper">
                  <h3>{{ store.name }}</h3>
                  <a
                    v-if="loggedIn"
                    @click.stop="
                      !checkIfLocationIsFavorited(store) ? addToFavorites(store) : removeFromFavorites(store)
                    "
                    class="favorite"
                  >
                    <svg
                      v-if="!checkIfLocationIsFavorited(store)"
                      class="favoriteEmpty"
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="28.043"
                      viewBox="0 0 32 28.043"
                    >
                      <path
                        id="heart"
                        d="M46.654,0A7.425,7.425,0,0,0,39.83,4.53,7.422,7.422,0,0,0,33.006,0C27.9,0,24.83,4.864,
                            24.83,8.874c0,6.719,15,16.959,15,16.959s15-10.238,15-16.958C54.83,4.864,51.758,0,46.654,0Z"
                        transform="translate(-23.83 1)"
                        fill="none"
                        stroke="#000"
                        stroke-width="3"
                      />
                    </svg>
                    <svg
                      v-if="checkIfLocationIsFavorited(store)"
                      class="favoriteFill"
                      xmlns="http://www.w3.org/2000/svg"
                      width="30"
                      height="25.832"
                      viewBox="0 0 30 25.832"
                    >
                      <path
                        id="heart-fill"
                        d="M46.654,0A7.425,7.425,0,0,0,39.83,4.53,7.422,7.422,0,0,0,33.006,0C27.9,0,24.83,
                      4.864,24.83,8.874c0,6.719,15,16.959,15,16.959s15-10.238,15-16.958C54.83,4.864,51.758,0,46.654,0Z"
                        transform="translate(-24.83)"
                        fill="#010101"
                      />
                    </svg>
                  </a>
                </div>
                <p v-if="selectedAddressLat && selectedAddressLng" class="distance">
                  {{ getDistance(selectedAddressLat, selectedAddressLng, store.latitude, store.longitude) }}
                  miles away
                </p>
                <p class="address1" v-if="!branding.display_options.hide_store_address">
                  {{ store.address1 }}, {{ store.city }},
                  {{ store.state }}
                  {{ store.postal_code }}
                </p>
                <p v-if="store?.subtitle">{{ store.subtitle }}</p>
                <div class="line" v-if="!branding.display_options?.hide_restaurant_phone_number">
                  <p>{{ formatPhoneNumber(store.phone) }}</p>
                </div>
                <div class="storeInfo">
                  <div class="line">
                    <p
                      :style="{
                        color: store.is_open ? 'var(--custom-green-color)' : 'var(--red-color)',
                      }"
                    >
                      {{ store.is_open ? 'Open Now' : 'Closed' }}
                    </p>
                    <a @click="expandViewHours(store)" class="hours" href="javascript:;">
                      <p>{{ checkExpandedHours(store) ? 'Hide' : 'View' }} Hours</p>
                    </a>
                    <p v-if="store.is_open">
                      {{ selectedService.display_name ? selectedService.display_name : selectedService.name }}
                      Time: {{ getServiceEstimates(store) }}
                    </p>
                  </div>
                  <div v-if="checkExpandedHours(store)" class="daysAndHours">
                    <p class="serviceTypeHoursHeader">
                      {{ selectedService.display_name || selectedService.name }} Hours
                    </p>
                    <div v-for="day in getWorkingTimeForDay(store.hours)" :key="day" class="day">
                      <p
                        :style="{
                          'font-family': isToday(day.day) ? 'var(--regular-bold-font)' : 'var(--regular-font)',
                          'text-decoration': isToday(day.day) ? 'underline' : 'none',
                        }"
                      >
                        {{ day.day }}
                      </p>
                      <div>
                        <p
                          :style="{
                            'font-family': isToday(day.day) ? 'var(--regular-bold-font)' : 'var(--regular-font)',
                            'text-decoration': isToday(day.day) ? 'underline' : 'none',
                          }"
                        >
                          {{ !day.start_time || !day.end_time ? 'Closed' : day.start_time + ' - ' + day.end_time }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <button
                @click.stop="selectStore(store, 'list')"
                :disabled="buttonLoader && clickedStoreId == store.store_id && from == 'list'"
              >
                <div
                  v-if="buttonLoader && clickedStoreId == store.store_id && from == 'list'"
                  class="loader buttonLoader"
                ></div>
                <template v-else>
                  {{ store.is_open || storeConfig?.disable_future_orders ? 'ORDER NOW' : 'ORDER AHEAD' }}
                </template>
              </button>
            </div>
          </div>
          <div v-if="!stores && !loading && selectedService?.requires_address" class="deliveryAddressMessage">
            <img :src="branding.menu_logo_url" alt="companyLogo" />
            <p>Enter delivery address to get started</p>
          </div>
        </div>
        <div v-if="loading" class="results">
          <div>
            <div v-for="store in 8" :key="store" class="store">
              <div class="storeInfoWrapper">
                <div class="storeNameWrapper">
                  <ShimmerView :height="'16px'" :width="'200px'" />
                  <ShimmerView :height="'16px'" :width="'16px'" :margin="'0px 0px 0px 0px'" />
                </div>
                <ShimmerView :height="'16px'" :width="'160px'" :margin="'5px 0px 0px 0px'" />
                <ShimmerView :height="'16px'" :width="'100px'" :margin="'5px 0px 5px 0px'" />
                <div class="storeInfo">
                  <div class="line">
                    <ShimmerView :height="'16px'" :width="'80px'" />
                    <ShimmerView :height="'16px'" :width="'80px'" />
                    <ShimmerView :height="'16px'" :width="'80px'" />
                  </div>
                </div>
                <ShimmerView :height="'50px'" :width="'100%'" :margin="'20px 0px 0px 0px'" />
              </div>
            </div>
          </div>
        </div>
        <p class="error" v-if="errorMessage">{{ errorMessage }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router'

import moment from 'moment'

import { mapState, mapMutations } from 'vuex'

import ChangeLocationModal from '@/components/Modals/StoreModals/ChangeLocationModal.vue'
import ChangeServiceTypeModal from '@/components/Modals/StoreModals/ChangeServiceTypeModal.vue'
import CustomPopup from '@/components/Modals/StoreModals/CustomPopup.vue'
import AutoComplete from '@/components/GoogleMaps/AutoComplete.vue'
import RadarAutoComplete from '@/components/GoogleMaps/RadarAutoComplete.vue'
import MapView from '@/components/GoogleMaps/MapView.vue'
import RadarMapView from '@/components/GoogleMaps/RadarMapView.vue'
import SegmentedControl from '@/components/Elements/SegmentedControl.vue'
import ShimmerView from '@/components/Elements/ShimmerView.vue'

import formattingMixins from '@/mixins/formattingMixins'
import addressMixins from '@/mixins/addressMixins'
import trackMainRoutes from '@/mixins/trackMainRoutes'
import fullStoryMixins from '@/mixins/fullStoryMixins'

import customersApi from '@/api/customersApi'
import storesApi from '@/api/storesApi'
import externalApi from '@/api/externalApi'

export default {
  name: 'HomeView',
  data() {
    return {
      stores: null,
      errorMessage: null,
      selectedStoreData: null,
      selectedStoreIndex: null,
      loading: false,
      selectedAddressLat: null,
      selectedAddressLng: null,
      viewHoursIsOpen: false,
      addresses: null,
      from: null,
      newAddress: null,
      addressData: null,
      serviceTypeListIsVisible: false,
      changeLocationModalIsOpen: false,
      newStoreId: null,
      changeServiceTypeModalIsOpen: false,
      updatedService: null,
      openViewHoursStoreIds: [],
      validAddressError: null,
      customPopUpIsVisible: false,
      aptSuite: '',
      addressTyped: false,
      getLocationLoader: false,
      selectedLocationTab: 'all',
      favoriteLocations: null,
      clickedStoreId: null,
      sortedStoreList: [],
    }
  },
  components: {
    ChangeLocationModal,
    ChangeServiceTypeModal,
    CustomPopup,
    AutoComplete,
    RadarAutoComplete,
    MapView,
    RadarMapView,
    SegmentedControl,
    ShimmerView,
  },
  mixins: [formattingMixins, addressMixins, fullStoryMixins],
  // spread operator used because beforeRouteLeave is not working with the mixin
  ...trackMainRoutes,
  watch: {
    favoriteLocations() {
      this.sortStores()
    },
    selectedService(newVal, oldVal) {
      if (oldVal == null && !newVal.requires_address) {
        this.displayStores()
      }
    },
    loggedIn(newVal, oldVal) {
      if (oldVal == false && newVal == true && this.selectedService.requires_address) {
        this.getAddresses()
      }
      if (oldVal == false && newVal == true && !this.selectedService.requires_address) {
        this.displayStores(true)
      }
    },
  },
  computed: {
    ...mapState([
      'storeConfig',
      'selectedService',
      'selectedStore',
      'buttonLoader',
      'loggedIn',
      'selectedAddress',
      'customerData',
      'orderData',
      'branding',
      'cookies',
      'mapType',
      'autoCompleteType',
    ]),
    visibleServices() {
      return this.storeConfig.services
        .filter((service) => service.is_visible)
        .sort((a, b) => (a.display_order ?? 0) - (b.display_order ?? 0))
    },
    firstTwoAddresses() {
      if (this.addresses) {
        return this.addresses.slice(0, 2)
      } else {
        return null
      }
    },
    filteredStores() {
      return this.sortedStoreList.filter((store) => {
        if (store.test_store) {
          return this.loggedIn && this.customerData?.is_mgmt
        }
        return true
      })
    },
  },
  methods: {
    ...mapMutations([
      'SET_STORE_CONFIG',
      'SET_SELECTED_SERVICE',
      'SET_SELECTED_STORE',
      'SET_BUTTON_LOADER',
      'SET_SELECTED_STORE_DAYS',
      'SET_SELECTED_ADDRESS',
      'SET_SELECTED_DAY',
      'SET_SELECTED_HOUR',
      'SET_DAY_AND_TIME_SELECTED',
      'SET_TOASTER',
      'SET_COOKIES',
      'SET_ORDER_DATA',
      'SET_AUTO_COMPLETE_TYPE',
      'SET_MAP_TYPE',
      'SET_LOGGED_IN',
      'SET_CUSTOMER_DATA',
      'SET_PHONE_VERIFIED',
    ]),
    toggleServiceTypeList() {
      this.serviceTypeListIsVisible = !this.serviceTypeListIsVisible
    },
    toggleChangeLocationModal() {
      this.changeLocationModalIsOpen = !this.changeLocationModalIsOpen
    },
    toggleChangeServiceTypeModal() {
      this.changeServiceTypeModalIsOpen = !this.changeServiceTypeModalIsOpen
    },
    toggleCustomPopUpModal() {
      this.customPopUpIsVisible = !this.customPopUpIsVisible
    },
    sortStores() {
      if (!this.selectedAddressLat && !this.selectedAddressLng) {
        this.sortedStoreList = this.stores?.slice().sort((a, b) => {
          const aFavorited = this.checkIfLocationIsFavorited(a)
          const bFavorited = this.checkIfLocationIsFavorited(b)

          if (aFavorited && !bFavorited) {
            return -1
          } else if (!aFavorited && bFavorited) {
            return 1
          } else {
            return a.name.localeCompare(b.name)
          }
        })
      } else {
        this.sortedStoreList = this.stores
      }
    },
    scrollToTheStore(storeId) {
      // scroll to the store that was clicked on the map
      let store = this.sortedStoreList.find((store) => store.store_id == storeId)
      let index = this.sortedStoreList.indexOf(store)
      let element = document.getElementsByClassName('store')[index]
      element.scrollIntoView({ behavior: 'smooth', block: 'center' })
    },
    checkIfLocationIsFavorited(store) {
      if (this.favoriteLocations) {
        let favoriteLocation = this.favoriteLocations.find((location) => location.store_id == store.store_id)
        if (favoriteLocation) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    openInfoWindow(store) {
      if (this.mapType == 'GOOGLE' && this.$refs.map) {
        this.$refs.map.openInfoWindow(store, store.store_id)
      }
      if (this.mapType == 'RADAR' && this.$refs.radarMap) {
        this.$refs.radarMap.openInfoWindow(store, store.store_id)
      }
    },
    async selectLocationTab(tab) {
      this.selectedLocationTab = tab
      if (tab == 'favorite') {
        // reset everything about address
        localStorage.removeItem('selectedAddress')
        this.addressData = null
        this.SET_SELECTED_ADDRESS(null)
        for (const location of this.favoriteLocations) {
          let store = this.stores?.find((store) => store.store_id === location.store_id)
          if (store) {
            // if store is in the list of stores, add the store data to the favorite location
            location.store = store
          } else {
            // if store is not in the list of stores, get the store data from the api
            let storeData = await this.getStoreData(location.store_id)
            location.store = storeData
          }
        }
      }
    },
    async addToFavorites(store) {
      let customerId = localStorage.getItem('customerId')
      let payload = {
        store_name: store.name,
        store_id: store.store_id,
      }
      customersApi
        .addFavoriteStore(payload, customerId)
        .then(async (response) => {
          let toasterData = {
            show: true,
            message: store.name + ' added to your favorites',
          }
          this.SET_TOASTER(toasterData)
          let favoriteLocationData = {
            store_id: store.store_id,
            restaurant_name: store.name,
          }
          let storeInfo = this.stores.find((store) => store.store_id === favoriteLocationData.store_id)
          if (storeInfo) {
            // if store is in the list of stores, add the store data to the favorite location
            favoriteLocationData.store = storeInfo
          } else {
            // if store is not in the list of stores, get the store data from the api
            let storeData = await this.getStoreData(favoriteLocationData.store_id)
            favoriteLocationData.store = storeData
          }
          this.favoriteLocations.push(favoriteLocationData)
          this.SET_COOKIES(response.data.cookies)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    removeFromFavorites(store) {
      let customerId = localStorage.getItem('customerId')
      let payload = {
        store_id: store.store_id,
      }
      customersApi
        .removeFavoriteStore(payload, customerId)
        .then((response) => {
          let storeName = store.name ? store.name : store.restaurant_name
          let toasterData = {
            show: true,
            message: storeName + ' removed from your favorites',
          }
          this.SET_TOASTER(toasterData)
          let removedLocation = this.favoriteLocations.find((location) => location.store_id == store.store_id)
          let index = this.favoriteLocations.indexOf(removedLocation)
          this.favoriteLocations.splice(index, 1)
          this.SET_COOKIES(response.data.cookies)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getUsersLocation() {
      this.getLocationLoader = true
      if (!navigator.geolocation) {
        return
      }
      // ask for permission to use the users location
      navigator.geolocation.getCurrentPosition(
        (position) => {
          // get the lat and lng of the users location
          this.selectedAddressLat = position.coords.latitude
          this.selectedAddressLng = position.coords.longitude
          /* this.addUserMarker() */
          if (this.$refs.radarMap) {
            this.$refs.radarMap.addUserMarker(this.selectedAddressLat, this.selectedAddressLng)
          }
          if (this.$refs.map) {
            this.$refs.map.addUserMarker(this.selectedAddressLat, this.selectedAddressLng)
          }
          // get the stores that are closest to the users location
          this.getStores(this.selectedService)
          this.getLocationLoader = false
        },
        () => {
          this.getLocationLoader = false
        }
      )
    },
    getWorkingTimeForDay(hours) {
      let days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
      let dayData = days.map((day) => ({ day: day, start_times: [], end_times: [] }))

      hours.forEach((hour) => {
        let dayIndex = hour.iso_dow - 1
        if (hour.start_time === '00:00') {
          dayIndex = dayIndex === 0 ? 6 : dayIndex - 1
        }
        dayData[dayIndex].start_times.push(hour.start_time)
        dayData[dayIndex].end_times.push(hour.end_time)
      })
      let formattedDayData = dayData.map((day) => {
        let start_times = day.start_times.sort()
        let end_times = day.end_times.sort()
        let start_time = start_times.length === 1 ? start_times[0] : start_times.find((time) => time > '05:00')
        let end_time = end_times.length === 1 ? end_times[0] : end_times.reverse().find((time) => time < '05:00')
        return {
          day: day.day,
          start_time: this.formatTime(start_time),
          end_time: this.formatTime(end_time),
        }
      })
      return formattedDayData
    },
    isToday(day) {
      let today = moment().format('dddd')
      if (day === today) {
        return true
      }
      return false
    },
    formatTime(time) {
      if (!time) return null
      return moment(time, 'HH:mm').format('h:mm A')
    },
    changeStore() {
      this.toggleChangeLocationModal()
      this.SET_ORDER_DATA(null)
      localStorage.removeItem('orderId')
      localStorage.removeItem('dayAndTimeSelected')
      this.SET_DAY_AND_TIME_SELECTED(false)
      localStorage.removeItem('selectedDay')
      this.SET_SELECTED_DAY(null)
      localStorage.removeItem('selectedHour')
      this.SET_SELECTED_HOUR(null)
      localStorage.removeItem('selectedTip')
      localStorage.removeItem('tipSelected')
      this.selectStore(this.newStoreData, 'list', true)
    },
    checkExpandedHours(storeData) {
      // check if view hours is expanded
      let expanded = this.openViewHoursStoreIds.find((store) => store.id === storeData.store_id)
      if (expanded) {
        return true
      }
      return false
    },
    expandViewHours(storeData) {
      // check if hours are already expanded
      let expanded = this.openViewHoursStoreIds.find((store) => store.id === storeData.store_id)
      if (expanded) {
        // remove from array
        this.openViewHoursStoreIds = this.openViewHoursStoreIds.filter((store) => store.id !== storeData.store_id)
      } else {
        // add to array
        this.openViewHoursStoreIds.push({ id: storeData.store_id })
      }
    },
    async getStores(service) {
      this.stores = null
      this.sortedStoreList = []
      this.loading = true
      this.errorMessage = null
      this.SET_SELECTED_SERVICE(service)
      localStorage.setItem('selectedServiceId', service.service_type_id)
      let payload = {
        all_stores: true,
        service_type_id: service.service_type_id,
        service_schedule: true,
      }
      if (service.requires_address) {
        delete payload.all_stores
      }
      if (this.selectedAddressLat && this.selectedAddressLng) {
        payload.latitude = this.selectedAddressLat
        payload.longitude = this.selectedAddressLng
      }
      await storesApi
        .getStores(payload)
        .then(async (response) => {
          this.loading = false
          this.errorMessage = null
          this.SET_COOKIES(response.data.cookies)
          this.stores = response.data.data
          this.sortStores()
          if (this.$refs.map) {
            this.$refs.map.createMarkers(this.stores, this.selectedAddressLat, this.selectedAddressLng)
          }
          if (this.$refs.radarMap) {
            this.$refs.radarMap.createMarkers(this.stores, this.selectedAddressLat, this.selectedAddressLng)
          }
        })
        .catch((error) => {
          console.log(error)
          this.loading = false
          if (
            error.response?.data.status == 400 &&
            error.response?.data.data.error == 'no stores found' &&
            !this.selectedService.requires_address
          ) {
            this.errorMessage = 'There are no locations within 25 miles'
            this.stores = []
            this.sortedStoreList = []
          } else {
            this.errorMessage = 'There are no locations delivering to your address'
            this.stores = []
            this.sortedStoreList = []
          }
        })
    },
    async getFavoriteLocations() {
      let customerId = localStorage.getItem('customerId')
      await customersApi
        .getFavoriteStores(customerId)
        .then(async (response) => {
          this.favoriteLocations = response.data.data
          this.SET_COOKIES(response.data.cookies)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    async getStoreData(storeId) {
      let storeData = null
      await storesApi
        .getStore(storeId)
        .then((response) => {
          storeData = response.data.data
          this.SET_COOKIES(response.data.cookies)
        })
        .catch((error) => {
          console.log(error)
        })
      return storeData
    },
    async guestCustomerLogin() {
      await customersApi
        .guestLogin()
        .then((response) => {
          if (response.data.data.ok == true) {
            localStorage.setItem('guestCustomerId', response.data.data.customer_id)
          }
          this.SET_COOKIES(response.data.cookies)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    async selectStore(store, from, changeStore) {
      if (typeof fbq === 'function') {
        fbq('track', 'ViewContent')
      }
      if (this.orderData && this.orderData.restaurant.store_id != store.store_id && !changeStore) {
        this.newStoreData = store
        this.toggleChangeLocationModal()
        return
      }
      this.from = from
      this.clickedStoreId = store.store_id
      this.SET_BUTTON_LOADER(true)
      if (this.addressData && this.selectedService.requires_address && !this.loggedIn) {
        // guest login
        await this.guestCustomerLogin()
        // save address
        await this.saveAddress()
      }
      let payload = {
        service_schedule: true,
        service_type_id: this.selectedService.service_type_id,
        store_id: store.store_id,
      }
      if (this.addressData && this.selectedService.requires_address && !this.newAddress) {
        payload.latitude = this.selectedAddress.latitude
        payload.longitude = this.selectedAddress.longitude
      } else if (this.addressData && this.selectedService.requires_address && this.newAddress) {
        payload.latitude = this.selectedAddressLat
        payload.longitude = this.selectedAddressLng
      }
      storesApi
        .getStore(null, payload)
        .then((response) => {
          this.SET_SELECTED_STORE(response.data.data[0])
          this.SET_COOKIES(response.data.cookies)
          localStorage.setItem('selectedStoreId', response.data.data[0].store_id)
          localStorage.setItem('timeZoneOffset', response.data.data[0].timezone_offset_mins)
          localStorage.setItem('deliveryInfo', JSON.stringify(response.data.data[0].delivery_info))
          if (this.addressData && this.newAddress && this.selectedService.requires_address) {
            this.saveAddress()
          }
          this.SET_BUTTON_LOADER(false)
          let storeId = localStorage.getItem('selectedStoreId')
          let storeName = store.name ? store.name : store.restaurant_name
          let storeNameAsSlug = storeName
            .toLowerCase()
            .replace(/ /g, '-')
            .replace(/[^\w-]+/g, '')
          router.push({
            name: 'MenuView',
            params: { storeId: storeId, storeName: storeNameAsSlug },
          })
          localStorage.setItem('selectedStoreName', storeName)
        })
        .catch((error) => {
          console.log(error)
          this.SET_BUTTON_LOADER(false)
          this.loading = false
          let toasterData = {
            show: true,
            message: 'Something went wrong. Please try again later',
          }
          this.SET_TOASTER(toasterData)
        })
    },
    async saveAddress() {
      let customerID = this.loggedIn ? localStorage.getItem('customerId') : localStorage.getItem('guestCustomerId')
      this.addressData.phone = this.customerData ? this.customerData.phone : null
      this.addressData.contact_phone = this.customerData ? this.customerData.phone : null
      this.addressData.address2 = this.aptSuite ? this.aptSuite : ''
      await customersApi
        .saveAddress(this.addressData, customerID)
        .then((response) => {
          localStorage.setItem('selectedAddress', JSON.stringify(response.data.data))
          this.SET_SELECTED_ADDRESS(response.data.data)
          this.SET_COOKIES(response.data.cookies)
        })
        .catch(() => {
          let toasterData = {
            show: true,
            message: 'Something went wrong. Please try again later',
          }
          this.SET_TOASTER(toasterData)
        })
    },
    zoomChanged(zoom) {
      this.zoom = zoom
    },
    addressValue(value) {
      if (value === '') {
        if (this.autoCompleteType == 'GOOGLE') {
          this.$refs.autoComplete.resetInput()
        }
        if (this.autoCompleteType == 'RADAR') {
          this.$refs.radarAutoComplete.resetAddressInput()
        }
        this.selectedAddressLat = null
        this.selectedAddressLng = null
        this.aptSuite = ''
        this.errorMessage = null
        this.validAddressError = null
        this.stores = null
        this.sortedStoreList = []
        this.addressTyped = false
        if (!this.selectedService.requires_address) {
          this.displayStores()
        }
      }
    },
    getLatAndLng(addressData) {
      if (!addressData) return
      if (this.autoCompleteType == 'GOOGLE') {
        this.getAddressComponents(addressData, false, true)
      }
      if (this.autoCompleteType == 'RADAR') {
        this.getRadarAddressComponents(addressData, false, true)
      }
      if (this.validAddressError) {
        return
      }
      this.stores = null
      this.sortedStoreList = []
      if (this.autoCompleteType == 'GOOGLE') {
        this.selectedAddressLat = addressData.geometry.location.lat()
        this.selectedAddressLng = addressData.geometry.location.lng()
      }
      if (this.autoCompleteType == 'RADAR') {
        this.selectedAddressLat = addressData.latitude
        this.selectedAddressLng = addressData.longitude
      }
      this.addressTyped = true
      this.SET_SELECTED_ADDRESS(null)
      this.newAddress = true
      localStorage.removeItem('selectedAddress')
      this.getStores(this.selectedService)
    },
    changeServiceType(service) {
      this.toggleChangeServiceTypeModal()
      this.SET_ORDER_DATA(null)
      localStorage.removeItem('orderId')
      localStorage.removeItem('dayAndTimeSelected')
      this.SET_DAY_AND_TIME_SELECTED(false)
      localStorage.removeItem('selectedDay')
      this.SET_SELECTED_DAY(null)
      localStorage.removeItem('selectedHour')
      localStorage.removeItem('selectedTip')
      localStorage.removeItem('tipSelected')
      this.SET_SELECTED_HOUR(null)
      this.selectedAddressLat = null
      this.selectedAddressLng = null
      this.aptSuite = ''
      this.changeService(service, true)
      this.validAddressError = null
    },
    changeService(service, changeService) {
      this.serviceTypeListIsVisible = false
      this.updatedService = service
      if (this.orderData && service.service_type_id != this.selectedService.service_type_id && !changeService) {
        this.toggleChangeServiceTypeModal()
        return
      }
      this.SET_SELECTED_SERVICE(service)
      localStorage.setItem('selectedServiceId', service.service_type_id)
      if (!service.requires_address) {
        this.stores = null
        this.sortedStoreList = []
        this.selectedAddressLat = null
        this.selectedAddressLng = null
        this.displayStores()
      } else {
        this.stores = null
        this.sortedStoreList = []
        if (this.mapType == 'GOOGLE' && this.$refs.map) {
          this.$refs.map.removeMarkers()
        }
        if (this.mapType == 'RADAR' && this.$refs.radarMap) {
          this.$refs.radarMap.removeMarkers()
        }
        if (this.loggedIn) {
          this.getAddresses()
        }
      }
      this.errorMessage = null
      if (this.autoCompleteType == 'GOOGLE') {
        this.$refs.autoComplete.resetInput()
      }
      if (this.autoCompleteType == 'RADAR') {
        this.$refs.radarAutoComplete.resetAddressInput()
      }
      this.selectedAddressLat = null
      this.selectedAddressLng = null
      this.validAddressError = null
    },
    getDistance(lat1, lon1, lat2, lon2) {
      var R = 6371 // Radius of the earth in km
      var dLat = this.deg2rad(lat2 - lat1) // deg2rad below
      var dLon = this.deg2rad(lon2 - lon1)
      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2)
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
      var d = R * c // Distance in km
      d = d * 0.621371 // convert d to miles
      return d.toFixed(2)
    },
    deg2rad(deg) {
      return deg * (Math.PI / 180)
    },
    getServiceEstimates(store) {
      let selectedServiceIndex = store.services.findIndex((service) => {
        return service.service_type_id === this.selectedService?.service_type_id
      })
      let selectedService = store.services[selectedServiceIndex]
      let estimate = selectedService?.lead_time ?? 0 + selectedService?.order_time_precision ?? 0
      /*
      If estimate is more than 120 mins, convert to hours with moment.
      This is added because some stores have estimates of 36 hours for catering.
      */
      if (estimate > 120) {
        estimate = moment.duration(estimate, 'minutes').asHours()
        // Round to nearest 0.5
        estimate = Math.round(estimate * 2) / 2
        estimate = estimate + ' hours'
      } else {
        estimate = estimate + ' mins'
      }
      return estimate
    },
    toggleViewHours(store) {
      this.selectedStoreData = store
      this.viewHoursIsOpen = !this.viewHoursIsOpen
    },
    getAddresses() {
      let customerID = localStorage.getItem('customerId')
      customersApi
        .getAddresses(customerID)
        .then((response) => {
          this.addresses = response.data.data
          this.SET_COOKIES(response.data.cookies)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    selectAddress(address) {
      this.SET_SELECTED_ADDRESS(address)
      localStorage.setItem('selectedAddress', JSON.stringify(address))
      this.newAddress = false
      this.stores = null
      this.sortedStoreList = []
      this.selectedAddressLat = address.latitude
      this.selectedAddressLng = address.longitude
      if (this.$refs.map) {
        this.$refs.map.addUserMarker(this.selectedAddressLat, this.selectedAddressLng)
      }
      if (this.$refs.radarMap) {
        this.$refs.radarMap.addUserMarker(this.selectedAddressLat, this.selectedAddressLng)
      }
      this.getStores(this.selectedService)
      let inputValue = address.address1 + ', ' + address.city + ', ' + address.state_code + ' ' + address.postal_code
      this.$refs.autoComplete.addInputValue(inputValue)
      this.aptSuite = address.address2
    },
    showCustomPopup() {
      let popUpShowed = localStorage.getItem('popUpShowed') ? true : false
      if (this.branding.display_options?.pop_up?.enable && !popUpShowed) {
        this.toggleCustomPopUpModal()
        if (this.branding.display_options?.pop_up?.show_once) {
          localStorage.setItem('popUpShowed', true)
        }
      }
    },
    moveFavoriteLocationsToTop() {
      if (!this.loggedIn) return
      // move favorite locations to the top of this.stores array
      let favoriteLocations = []
      let otherLocations = []
      this.stores.forEach((store) => {
        // if store.store_id is exists in favoriteLocations array, push to favoriteLocations
        if (this.favoriteLocations?.find((favoriteLocation) => favoriteLocation.store_id == store.store_id)) {
          favoriteLocations.push(store)
        } else {
          otherLocations.push(store)
        }
      })
      this.stores = favoriteLocations.concat(otherLocations)
    },
    async displayStores(newLogin) {
      this.loading = true
      // first get location from ip address
      externalApi
        .getLocationByIp()
        .then(async (response) => {
          let location = {
            lat: response.data.latitude,
            lng: response.data.longitude,
          }
          // then if user is logged in get user's favorite locations
          if (this.loggedIn) {
            await this.getFavoriteLocations()
          }
          if (!newLogin) {
            // then get stores
            await this.getStores(this.selectedService)
          }
          if (response.data) {
            // add distance to each store
            this.stores.forEach((store) => {
              store.distance = this.getDistance(location.lat, location.lng, store.latitude, store.longitude)
            })
            // sort stores by distance
            this.stores.sort((a, b) => {
              return a.distance - b.distance
            })
          }
          this.moveFavoriteLocationsToTop()
          this.loading = false
        })
        .catch(async (error) => {
          console.log(error)
          if (this.loggedIn) {
            await this.getFavoriteLocations()
          }
          await this.getStores(this.selectedService)
          this.moveFavoriteLocationsToTop()
          this.loading = false
        })
    },
    setAutoCompleteType() {
      if (this.storeConfig?.enable_google_places_api) {
        this.SET_AUTO_COMPLETE_TYPE('GOOGLE')
      } else {
        this.SET_AUTO_COMPLETE_TYPE('RADAR')
      }
    },
    setMapType() {
      if (this.storeConfig?.enable_google_maps_api) {
        this.SET_MAP_TYPE('GOOGLE')
      } else {
        this.SET_MAP_TYPE('RADAR')
      }
    },
    foreignAuthLoginIfNeeded() {
      if (this.loggedIn) {
        return
      }
      const query = new URLSearchParams(window.location.search)
      const provider = query.get('auth_provider')
      const token = query.get('auth_access_token')

      if (provider && token) {
        const payload = {
          provider: provider,
          auth_info: {
            access_token: token,
          },
        }
        customersApi
          .foreignAuth(payload)
          .then((response) => {
            localStorage.setItem('customerId', response.data.data.customer_id)
            this.SET_COOKIES(response.data.cookies)
            this.getCustomerInfo()
          })
          .catch((error) => {
            console.log(error)
            this.$emit('ssoError')
          })
      }
    },
    getCustomerInfo() {
      this.SET_BUTTON_LOADER(true)
      customersApi
        .getCustomerInfo()
        .then((response) => {
          let toasterData = {
            show: true,
            message: 'Welcome back',
          }
          this.SET_TOASTER(toasterData)
          this.SET_CUSTOMER_DATA(response.data.data)
          // for FullStory
          this.identifyUser(response.data.data)
          this.SET_PHONE_VERIFIED(response.data.data.is_phone_verified)
          localStorage.setItem('phoneVerified', response.data.data.is_phone_verified)
          this.SET_LOGGED_IN(true)
          this.SET_BUTTON_LOADER(false)
          this.SET_COOKIES(response.data.cookies)
        })
        .catch((error) => {
          console.log(error)
        })
    },
  },
  created() {
    if (this.loggedIn) {
      this.getAddresses()
    }
    if (this.selectedService && !this.selectedService.requires_address) {
      this.displayStores()
    }
    localStorage.removeItem('selectedStoreName')
    let title = localStorage.getItem('title')
    document.title = title
    this.setAutoCompleteType()
    this.setMapType()
  },
  mounted() {
    this.showCustomPopup()
    this.foreignAuthLoginIfNeeded()
  },
}
</script>

<style src="../assets/css/views/HomeView.css" scoped></style>
